export default __webpack_public_path__ + "static/media/gbl.68e99c84.svg";